import Svg, { Path, Rect } from "react-native-svg";

const ImageIcon = ({ size }: DocumentIconSVG) => {
  return (
    <Svg fill="none" height={size} viewBox="0 0 36 36" width={size}>
      <Rect fill="#6492F9" height="36" rx="8" width="36" />
      <Path
        d="M24.75 12.0625H11.25C10.9336 12.0625 10.6875 12.3438 10.6875 12.625V23.875V23.9102L10.8281 23.6992L13.6406 19.7617C13.8164 19.5156 14.0625 19.375 14.3438 19.375C14.5898 19.375 14.8711 19.5156 15.0117 19.7266L16.1016 21.2383L19.0195 17.4766C19.1602 17.2656 19.4062 17.125 19.6875 17.125C19.9336 17.125 20.1797 17.2656 20.3555 17.4766L25.1367 23.6641L25.3125 23.875V12.625C25.3125 12.3438 25.0312 12.0625 24.75 12.0625ZM11.25 10.375H24.75C25.9805 10.375 27 11.3945 27 12.625V23.875C27 25.1406 25.9805 26.125 24.75 26.125H11.25C9.98438 26.125 9 25.1406 9 23.875V12.625C9 11.3945 9.98438 10.375 11.25 10.375ZM14.0625 17.125C13.4297 17.125 12.9023 16.8086 12.5859 16.2812C12.2695 15.7891 12.2695 15.1211 12.5859 14.5938C12.9023 14.1016 13.4297 13.75 14.0625 13.75C14.6602 13.75 15.1875 14.1016 15.5039 14.5938C15.8203 15.1211 15.8203 15.7891 15.5039 16.2812C15.1875 16.8086 14.6602 17.125 14.0625 17.125Z"
        fill="white"
      />
    </Svg>
  );
};

export default ImageIcon;
